import { createFileRoute, redirect } from "@tanstack/react-router";

// The Board view now lives inside the unified planning workspace; preserve the
// farm scope and land on `?view=board`.
export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/planning/tasks/kanban",
)({
	// Pure redirect into the workspace — must stay traversable offline.
	staticData: { offline: "ready" },
	beforeLoad: ({ params, search }) => {
		throw redirect({
			to: "/app/org/$orgId/planning",
			params: { orgId: params.orgId },
			search: { farm: (search as { farm?: string }).farm, view: "board" },
		});
	},
});
